import React from "react";
import { getCsrfToken } from "../api/authProvider";

export function HiddenInputCsrfToken() {
    const csrf = getCsrfToken();
    return csrf && <input type="hidden" name={csrf.parameterName} value={csrf.token}/>;
}